import {Injectable} from '@angular/core';
import {GenericEventModel} from '@atumverse/core-models';
import {
  AlertService,
  ConfigLoaderService,
  EventsService,
  FinfraMenuService,
  FinfraSidenavService,
  InjectionService
} from '@atumverse/core-services';
import {Subscription} from 'rxjs';
import {FinfraPortalPageTopService, FinfraPortalTopnavService} from '@atumverse/portal-app';
import {
  FinfraApplicationDateTopnavWidgetComponent,
  FinfraNotificationWidgetComponent,
  FinfraUserMenuTopnavWidgetComponent,
  FinfraAlertHistoryTopnavWidgetComponent,
} from '@atumverse/app-core-widgets';
import {FinfraUserPreferenceService} from '@atumverse/iam-app';
import {FinfraPageTopBreadcrumbWidgetComponent} from '../../finfra-studio/pages/finfra-studio-designer/widgets/page-top-breadcrumb-widget/page-top-breadcrumb-widget.component';


@Injectable({
  providedIn: 'root',
})
export class InjectService {
  public eventSubscription: Subscription;

  constructor(
    private injectionService: InjectionService,
    private alertService: AlertService,
    private eventsService: EventsService,
    private finfraPortalTopnavService: FinfraPortalTopnavService,
    private finfraMenuService: FinfraMenuService,
    private finfraUserPreferenceService: FinfraUserPreferenceService,
    private finfraPortalPageTopService: FinfraPortalPageTopService,
    private finfraSidenavService: FinfraSidenavService,
    private configLoaderService: ConfigLoaderService
  ) {
    this.eventSubscription = this.eventsService.listenEvents().subscribe(this.listenEvents.bind(this));
  }

  public initialize(): void {
    this.alertService.debug('We will start injecting our services here');

    this.injectionService.injectService('topnav-initialize', 'finfra-menu-service', this.finfraMenuService, 'init');
    this.injectionService.injectService('topnav-initialize', 'finfra-user-preference-service', this.finfraUserPreferenceService, 'init');

    this.injectionService.injectService('app-reset', 'finfra-menu-service', this.finfraMenuService, 'destroy');
    this.injectionService.injectService('app-reset', 'finfra-config-loder-service', this.configLoaderService, 'destroy');
  }

  public listenEvents(event: GenericEventModel): void {
    if (event.eventSource === 'finfra-portal-app' && event.eventName === 'finfra-topnav' && event.eventType === 'afterViewInit') {
      this.finfraPortalTopnavService.addWidget(FinfraAlertHistoryTopnavWidgetComponent, 'end');
      this.finfraPortalTopnavService.addWidget(FinfraNotificationWidgetComponent, 'end');
      this.finfraPortalTopnavService.addWidget(FinfraUserMenuTopnavWidgetComponent, 'end');
    }

    if (event.eventSource === 'finfra-pagetop' && event.eventName === 'finfra-pagetop' && event.eventType === 'afterViewInit') {
      this.finfraPortalPageTopService.addWidget(FinfraPageTopBreadcrumbWidgetComponent);
      this.finfraPortalPageTopService.addWidget(FinfraApplicationDateTopnavWidgetComponent);
    }
  }
}
